<agm-map [latitude]="lat" [longitude]="lng" [zoom]="zoom"
	[fitBounds]="true">
	<agm-marker [latitude]="lat" [longitude]="lng" [agmFitBounds]="true" [iconUrl]="'assets/markers/default.png'"></agm-marker>
	<!-- <agm-marker class="shop-marker" [latitude]="shopLat" [longitude]="shopLong" [agmFitBounds]="true" [iconUrl]="'https://mt.google.com/vt/icon/name=icons/spotlight/shopping_search_L_8x.png&scale=1'"> -->
	<agm-marker class="shop-marker" [latitude]="shopLat" [longitude]="shopLong" [agmFitBounds]="true" [iconUrl]="'assets/markers/office.png'">
	</agm-marker>
</agm-map>
